export const roundToNearest = (num: number, map: number[]) => {
  const sign = Math.sign(num);
  const absNum = Math.abs(num);
  const nearest = map.reduce((prev, curr) => {
    return Math.abs(curr - absNum) < Math.abs(prev - absNum) ? curr : prev;
  });

  return sign * nearest;
};
